/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import Logo from '../../images/logo-icon.png';

interface Styles {
  [key: string]: any;
}

interface SizeStyles {
  sm: Styles,
  md: Styles,
  lg: Styles,
}

const defaultStyle = {
  loader: {
    margin: '-50px 0 0 -50px',
    width: '100px',
    height: '100px'
  },
  image: {
    margin: '-75px 0 0 -25px',
    width: '50px'
  }
};

const sizeStyles: SizeStyles = {
  sm: {
    loader: {
      margin: '-25px 0 0 -25px',
      width: '75px',
      height: '75px'
    },
    image: {
      margin: '-50px 0 0 0',
      width: '25px'
    }
  },
  md: defaultStyle,
  lg: {
    loader: {
      margin: '-75px 0 0 -75px',
      width: '150px',
      height: '150px'
    },
    image: {
      margin: '-125px 0 0 -50px',
      width: '100px'
    }
  },
}

const relativeWrapperStyles = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate3d(-50%,-50%,0)',
  zIndex: 10,
}

interface LoaderProps {
  relative?: boolean;
  size?: keyof SizeStyles;
}

const Loader = ({ relative, size }: LoaderProps) => {

  const { loader, image } = size && size in sizeStyles ? sizeStyles[size] : defaultStyle;

  return (
    <div style={relative ? {} : relativeWrapperStyles}>
      <div id='loader' style={loader} />
      <img id='loader-img' style={image} src={Logo} alt='logo-icon' />
    </div>
  )
}

export default Loader;
